import React from 'react';

export const MapContext = React.createContext();
MapContext.displayName = 'Map context provider';

export const MapProvider = MapContext.Provider;
